export default __webpack_public_path__ + "281e0938dd0d7738dbbbd6a3927360d3.svg";